import React from 'react';
import { Link } from 'react-router-dom';
import { getPublicAssetPath } from '../config';

const Unauthorized: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4 sm:px-6 lg:px-8">
      <div className="max-w-2xl w-full text-center">
        {/* Logo */}
        <div className="flex items-center justify-center mb-8">
          <img src={getPublicAssetPath('/le_long.png')} alt="Legitimu Logo" className="h-12" />
        </div>

        {/* 401 Illustration */}
        <div className="mb-8">
          <div className="relative inline-block">
            <div className="text-9xl font-bold text-red-100">401</div>
            <div className="absolute inset-0 flex items-center justify-center">
              <i className="fa-solid fa-lock text-6xl text-red-400"></i>
            </div>
          </div>
        </div>

        {/* Error Message */}
        <div className="mb-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Akses Ditolak</h1>
          <p className="text-lg text-gray-600 mb-2">
            Maaf, Anda tidak memiliki izin untuk mengakses halaman ini.
          </p>
          <p className="text-sm text-gray-500">
            Halaman ini memerlukan autentikasi atau permission khusus yang tidak dimiliki oleh akun Anda.
          </p>
        </div>

        {/* Warning Info */}
        <div className="bg-red-50 border border-red-200 rounded-lg p-6 mb-8">
          <div className="flex items-start">
            <div className="flex-shrink-0">
              <i className="fa-solid fa-triangle-exclamation text-red-600 text-2xl"></i>
            </div>
            <div className="ml-4 text-left">
              <h3 className="text-sm font-semibold text-red-900 mb-2">Akses Terbatas</h3>
              <p className="text-sm text-red-700">
                Jika Anda yakin seharusnya memiliki akses ke halaman ini, silakan hubungi administrator untuk meminta permission yang sesuai.
              </p>
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
          <Link
            to="/dashboard"
            className="inline-flex items-center px-6 py-3 bg-violet-600 text-white text-sm font-medium rounded-lg hover:bg-violet-700 transition-colors"
          >
            <i className="fa-solid fa-home mr-2"></i>
            Kembali ke Dashboard
          </Link>
          <button
            onClick={() => window.history.back()}
            className="inline-flex items-center px-6 py-3 border border-gray-300 text-gray-700 text-sm font-medium rounded-lg hover:bg-gray-50 transition-colors"
          >
            <i className="fa-solid fa-arrow-left mr-2"></i>
            Kembali Sebelumnya
          </button>
        </div>

        {/* Permission Info */}
        <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6 mb-8">
          <h3 className="text-sm font-semibold text-gray-900 mb-4 flex items-center justify-center">
            <i className="fa-solid fa-shield-halved text-red-600 mr-2"></i>
            Informasi Permission
          </h3>
          <div className="text-left space-y-3">
            <div className="flex items-start">
              <i className="fa-solid fa-circle-check text-green-500 mr-3 mt-1"></i>
              <div>
                <p className="text-sm font-medium text-gray-900">Akses yang Diperlukan</p>
                <p className="text-xs text-gray-600">Halaman ini memerlukan role atau permission khusus</p>
              </div>
            </div>
            <div className="flex items-start">
              <i className="fa-solid fa-user-shield text-violet-500 mr-3 mt-1"></i>
              <div>
                <p className="text-sm font-medium text-gray-900">Hubungi Administrator</p>
                <p className="text-xs text-gray-600">Minta administrator untuk memberikan akses yang sesuai</p>
              </div>
            </div>
            <div className="flex items-start">
              <i className="fa-solid fa-key text-orange-500 mr-3 mt-1"></i>
              <div>
                <p className="text-sm font-medium text-gray-900">Cek Permission Anda</p>
                <p className="text-xs text-gray-600">Lihat halaman Profile untuk melihat role dan permission Anda</p>
              </div>
            </div>
          </div>
        </div>

        {/* Helpful Links */}
        <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6">
          <h3 className="text-sm font-semibold text-gray-900 mb-4">Butuh Bantuan?</h3>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/support"
              className="inline-flex items-center px-4 py-2 text-sm text-violet-600 hover:text-violet-700 hover:bg-violet-50 rounded-lg transition-colors"
            >
              <i className="fa-solid fa-life-ring mr-2"></i>
              Hubungi Support
            </Link>
            <Link
              to="/profile"
              className="inline-flex items-center px-4 py-2 text-sm text-violet-600 hover:text-violet-700 hover:bg-violet-50 rounded-lg transition-colors"
            >
              <i className="fa-solid fa-user mr-2"></i>
              Lihat Profile
            </Link>
            <Link
              to="/documentation"
              className="inline-flex items-center px-4 py-2 text-sm text-violet-600 hover:text-violet-700 hover:bg-violet-50 rounded-lg transition-colors"
            >
              <i className="fa-solid fa-book mr-2"></i>
              Dokumentasi
            </Link>
          </div>
        </div>

        {/* Additional Info */}
        <div className="mt-8">
          <p className="text-xs text-gray-500">
            Jika Anda adalah administrator dan mengalami masalah akses, silakan hubungi{' '}
            <a href="mailto:admin@legitimu.com" className="text-violet-600 hover:text-violet-700 font-medium">
              admin@legitimu.com
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Unauthorized;

